/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { oidcScopes, apiRequest } from './authConfig.js';

const isAadsts500207 = (error) => {
    const message = error?.message || error?.errorMessage || '';
    const code = error?.errorCode || error?.error || '';
    return code === 'invalid_request' && message.includes('500207');
};

/**
 * Acquire an access token for API calls.
 * 1. Try the custom api:// scope (for APIM) — requires a separate single-tenant API app in CIAM.
 * 2. Fall back to OIDC scopes (Graph token) so login/bootstrap never fails.
 */
export async function acquireAccessToken(instance, account) {
    if (apiRequest.scopes.length > 0) {
        try {
            return await instance.acquireTokenSilent({
                scopes: apiRequest.scopes,
                account,
            });
        } catch (error) {
            if (isAadsts500207(error)) {
                console.error(
                    '[Auth] AADSTS500207 — CIAM consumer accounts cannot use this api:// scope.\n' +
                    'Fix in Azure: create a SEPARATE API app registration (single-tenant), expose access_as_user there,\n' +
                    'grant jewelvaultwebapp permission to that API, then set REACT_APP_API_SCOPE to api://<api-app-id>/access_as_user'
                );
            } else {
                console.warn(
                    'Silent API-scope token failed — check Expose an API + admin consent. Falling back to OIDC token.',
                    error?.errorCode || error?.message
                );
            }
        }
    }

    return instance.acquireTokenSilent({
        scopes: oidcScopes,
        account,
    });
}

export function hasPersistedSession() {
    return !!(localStorage.getItem('objectId') && localStorage.getItem('token'));
}

export function getAccountEmail(account) {
    return (
        account?.idTokenClaims?.email ||
        account?.username ||
        localStorage.getItem('email') ||
        ''
    );
}
